import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import lodingDialog from '@/components/dialog/login/index'
import { baseUrl } from '@/env/index'
const Qs = require('qs');

export interface RequestResponse {
    success: boolean;
    message: string;
    data: any;
}

axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8'
// axios.defaults.headers['Qunar-Uid'] = '10000036'

/**
 * 封装一层 axios
 */
export class Request {
    private axios: AxiosInstance;
    public constructor() {
        this.axios = axios.create({
            // 在服务器端请求的时候，需要设置请求的基本地址
            baseURL: baseUrl,
            //baseURL:'https://adqunar.qunar.com/adperiapi/',
            //baseURL: 'http://adperi.beta.qunar.com/api/',
            timeout: 5000,
            validateStatus: () => true
        });
        this.axios.interceptors.request.use(async (config) => {
            config.data = Qs.stringify(config.data);
            return config;
        });
        this.axios.interceptors.response.use(response => {
            // let isGetUserInfo = (response as any).config.url.indexOf('loreal/userInfo')!=-1
            // if(response.status==200){
            //     if(response.data.code>=400&&response.data.code<=500){
            //         if(!isGetUserInfo){
            //             lodingDialog();
            //         }
            //     }
            // }
            return response
          })
        
        // this.axios.defaults.transformRequest = function (data) {
        //     //data = Qs.stringify(data);
        //     data = Qs.stringify(data);
        //     return data;
        // };  
    }

    /**
     * 获取数据
     */
    public get(
        url: string,
        config: AxiosRequestConfig = {}
    ): Promise<RequestResponse> {
        return this.axios
            .get(url, config)
            .then(this.success)
            .catch(this.error);
    }
    /**
     * 提交数据
     */
    public post(url: string, data: any = {}, config: AxiosRequestConfig = {}) {
        return this.axios
            .post(url, data, config)
            .then(this.success)
            .catch(this.error);
    }
    /**
     * 更新数据
     */
    public put(url: string, data: any = {}, config: AxiosRequestConfig = {}) {
        return this.axios
            .put(url, data, config)
            .then(this.success)
            .catch(this.error);
    }
    /**
     * 删除数据
     */
    public delete(url: string, config: AxiosRequestConfig = {}) {
        return this.axios
            .delete(url, config)
            .then(this.success)
            .catch(this.error);
    }
    /**
     * 处理请求成功
     */
    private success<T>(res: AxiosResponse): Promise<RequestResponse> {
        return res.data;
    }
    /**
     * 处理请求失败
     */
    private async error(err: Error): Promise<RequestResponse> {
        return {
            success: false,
            message: '请求失败',
            data: null
        };
    }
}

/**
 * 创建一个请求对象
 */
export const createRequest = () => {
    return new Request();
};

declare module 'vue/types/options' {
    interface ComponentOptions<V extends Vue> {
        request?: Request;
    }
}